module.exports = __webpack_public_path__ + "img/gaotao_pink.d49cc79f.png";